export default "__VITE_ASSET__BPyR9sxO__"